import { Svg } from 'common/assets'
import { useResolution } from 'common/hooks'
import { GeneralMenu } from 'modules/GeneralMenu'
import { LoadingApps } from 'modules/LoadingApps'
import { memo } from 'react'
import { Comopnent } from './components'
import { Container, StyledLogo } from './styled'
import { Link } from 'react-router-dom'

export const Header = () => {
  const { isMinScreen768, isMinScreen1000 } = useResolution()
  return (
    <>
      <Container>
        <Link to={'/'}>
          <StyledLogo src={Svg.Logo} alt="logo" />
        </Link>
        {isMinScreen1000 && <GeneralMenu />}
        {isMinScreen768 && <LoadingApps />}
        <Comopnent.RightMenu />
      </Container>
    </>
  )
}
